"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
require("rxjs/add/operator/map");
var environment_1 = require("../../environments/environment");
var unit_1 = require("./unit");
var api_service_1 = require("../shared/api.service");
var UnitService = /** @class */ (function () {
    function UnitService(http) {
        this.http = http;
        this.baseUrl = environment_1.environment.serverUrl;
        this.params = new http_1.HttpParams();
        this.count = 0;
        this.params = new http_1.HttpParams();
    }
    UnitService.prototype.list = function (query) {
        var _this = this;
        if (query === void 0) { query = null; }
        if (query) {
            Object.keys(query).forEach(function (key) {
                if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
                    _this.params = _this.params.set(key, query[key].toString());
                }
            });
        }
        var unitsUrl = '/assets/files/units.json';
        return this.http.get(unitsUrl, {
            headers: api_service_1.requestHeaders(),
            params: this.params
        }).map(function (res) {
            return _this.extractData(res);
        });
    };
    UnitService.prototype.extractData = function (res) {
        var resObj = res;
        this.nextUri = resObj['next'];
        this.count = resObj['count'];
        var body = resObj['results'];
        if (body) {
            return body.map(function (unit) {
                return new unit_1.Unit(unit);
            });
        }
        else if (resObj) {
            return new unit_1.Unit(resObj);
        }
        else {
            return {};
        }
    };
    return UnitService;
}());
exports.UnitService = UnitService;
